import React from 'react';
import Icon, { IconName } from '../common/Icon';
import H from '../elements/H';

interface IconLabelVerticalProps {
  icon: IconName;
}

const IconLabelVertical: React.FunctionComponent<IconLabelVerticalProps> = ({
  icon,
  children
}) => {
  return (
    <div>
      <Icon name={icon} size={2} />
      <H styling="h4" tag="div" data>
        {children}
      </H>
    </div>
  );
};

export default IconLabelVertical;
